import work from "../assets/work.webp";
import bio from "../assets/bio.webp";
import contact from "../assets/contact.webp";

export const pages = [
  {
    id: 1,
    title: "work.",
    url: "/work",
    background: work,
  },
  {
    id: 2,
    title: "bio.",
    url: "/bio",
    background: bio,
  },
  {
    id: 3,
    title: "contact.",
    url: "/contact",
    background: contact,
  },
];
